import { render, staticRenderFns } from "./ShowMeasurements.vue?vue&type=template&id=6d60fb18&"
import script from "./ShowMeasurements.vue?vue&type=script&lang=js&"
export * from "./ShowMeasurements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports